export default function initMiniMenu() {
    const menu = document.querySelector('.mini-sub-menu');
    if (menu) {
        const activeMenuItem = menu.querySelector('.clean-link.active');
        const activeMenuItemBB = activeMenuItem.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        menu.scrollLeft = Math.abs(windowWidth / 2 - activeMenuItemBB.x - activeMenuItemBB.width / 2);

        if (activeMenuItemBB.x + activeMenuItemBB.width / 2 > windowWidth / 2) {
            menu.scrollLeft = Math.abs(windowWidth / 2 - activeMenuItemBB.x - activeMenuItemBB.width / 2);
        } else {
            menu.scrollLeft = 0;
        }
    }
}
